import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale/pt-BR'

const numberFormat = new Intl.NumberFormat('pt-BR', { currency: 'BRL', style: 'currency' })

export const formatToBrCurrency = (value: number, divideBy: number = 100) => {
  const newValue = value / divideBy
  return numberFormat.format(newValue)
}

export const formatToDecimal = (value: number) => value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })

export function formatDateWithoutSlash(date: Date) {
  return format(date, "dd MMM yyyy 'às' HH:mm", { locale: ptBR })
}

/**
 * Formats a masked currency string in BRL to cents as a number.
 *
 * @param value Masked currency in BRL format.
 * @returns Cents in number.
 *
 * @example
 * formatCurrencyToCents('R$ 1.550,42') // 155042
 */
export function formatCurrencyToCents(value: string): number {
  const cleanedValue = value.replace(/\D+/g, '')

  return parseInt(cleanedValue)
}
